<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
          <el-form-item label="开始日期" prop="startDate">
            <el-date-picker
              v-model="queryParams.startDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item label="结束日期" prop="endDate">
            <el-date-picker
              v-model="queryParams.endDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              @keyup.enter.native="handleQuery"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">查询</el-button>
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>-->
            <!--            <el-button icon="el-icon-refresh" size="mini" @click="exportData">导出</el-button>-->
          </el-form-item>
        </el-form>

        <div slot="header" class="clearfix">
          <span>建筑统计</span>
        </div>

        <el-table
          :data="tableData"
          border
          style="width: 100%;"
        >
          <el-table-column
            prop="date"
            label="日期"
            align="center"
          />
          <el-table-column
            label="建筑统计"
            align="center"
          >
            <el-table-column
              prop="build_count"
              label="建筑总数"
              align="center"
            />
            <el-table-column
              prop="build_user"
              label="建筑人数"
              align="center"
            />
            <el-table-column
              prop="build_avg"
              label="人均建筑次数"
              align="center"
            />
            <el-table-column
              prop="build_num"
              label="花费"
              align="center"
            >
              <template scope="scope">
                {{ scientificFormat(scope.row.build_num) }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            label="修复统计"
            align="center"
          >
            <el-table-column
              prop="fixes_count"
              label="修复总数"
              align="center"
            />
            <el-table-column
              prop="fixes_user"
              label="修复人数"
              align="center"
            />
            <el-table-column
              prop="fixes_avg"
              label="人均修复次数"
              align="center"
            />
            <el-table-column
              prop="fixes_num"
              label="花费"
              align="center"
            >
              <template scope="scope">
                {{ scientificFormat(scope.row.fixes_num) }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-card>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <userStat ref="userStat" />
        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <buildNum ref="buildNum" />
        </el-col>
      </el-row>

      <el-row :gutter="12">
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <userCount ref="userCount" />

        </el-col>
        <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
          <buildAvg ref="buildAvg" />
        </el-col>
      </el-row>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserBuildStat } from '@/api/user/user_info'
import userStat from '@/views/config/build-stat/components/user-build-stat.vue'
import userCount from '@/views/config/build-stat/components/user-count-stat.vue'
import buildAvg from '@/views/config/build-stat/components/build-avg-stat.vue'
import buildNum from '@/views/config/build-stat/components/build-num-stat.vue'
import { getCacheQuery, getLastDates, scientificFormat, setCacheQuery } from '@/utils'
export default {
  name: 'BuildStat',
  components: {
    userStat,
    userCount,
    buildAvg,
    buildNum
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        startDate: '',
        endDate: ''
      },
      ridData: {},
      tableData: []
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(0)
    }

    this.getTables(undefined)
  },
  methods: {
    scientificFormat,
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      this.getTables({})
    },
    resetQuery() {
      this.queryParams.uid = ''
      this.resetForm('queryForm')
      this.handleQuery()
    },
    getTables(event) {
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserBuildStat(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        if (res.code === 200) {
          this.tableData = res.data
          this.$refs.userStat.refresh(this.tableData)
          this.$refs.userCount.refresh(this.tableData)
          this.$refs.buildAvg.refresh(this.tableData)
          this.$refs.buildNum.refresh(this.tableData)
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
